export default function WhatsAppButton() {
  const phoneNumber = '33606702620'; // Format international sans le +
  const message = encodeURIComponent('Bonjour, je souhaite obtenir des informations sur vos services de transport de fleurs.');

  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 bg-[#25D366] text-white w-14 h-14 rounded-full shadow-lg hover:bg-[#20BA5A] transition-all duration-300 flex items-center justify-center z-50 hover:scale-110 cursor-pointer"
      aria-label="Nous contacter sur WhatsApp"
    >
      <i className="ri-whatsapp-line text-3xl"></i>
    </button>
  );
}
